import Vue from 'vue'
// 滚动条组件
import GeminiScrollbar from 'vue-gemini-scrollbar'

Vue.config.productionTip = false
Vue.use(GeminiScrollbar)

// global css
import '@/styles/index.scss'

// global filters
import * as filters from 'filters' // global filters
// register global utility filters.
Object.keys(filters).forEach(key => {
  Vue.filter(key, filters[key])
})

// 状态
import Vuex from 'vuex'
import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css';
Vue.use(Vuex)
Vue.use(ElementUI);
const store = new Vuex.Store({
  state: {

  },
  mutations: {

  },
  actions: {

  }
})

// 路由
import Router from 'vue-router'
Vue.use(Router)
const router = new Router({
  routes: [{
      path: '/',
      name: 'index',
      component: r => {
        require(['./index'], r)
      },
      meta: {
        title: '课程集锦'
      }
    }, {
      path: '/video',
      name: 'video',
      component: r => {
        require(['./video'], r)
      },
      meta: {
        title: '视频详情'
      }
    }, {
      path: '/commentDetail',
      name: 'commentDetail',
      component: r => {
        require(['./commentDetail'], r)
      },
      meta: {
        title: '评论详情'
      }
    },
    {
      path: '/pdfList',
      name: 'pdfList',
      component: r => {
        require(['./pdfList'], r)
      },
      meta: {
        title: 'pdf列表'
      }
    },
    {
      path: '/pdfDetail',
      name: 'pdfDetail',
      component: r => {
        require(['./pdfDetail'], r)
      },
      meta: {
        title: 'pdf列表'
      }
    }
  ]
})

import App from '../App.vue'
new Vue({
  router,
  store,
  el: '#app',
  render: h => h(App)
}).$mount('#app')